<script setup lang="ts">
const flightType = ref("Pergi/Pulang");
</script>
<template>
    <!-- Card Menu Transaksi -->
    <div class="container">
      <div class="container mt-4 border-0 rounded-2 rounded-start-4 card mb-3 shadow">
        <!-- Tab Menu Transaksi -->
        <TabMobileMenu />
        <!-- End Tab Menu Transaksi-->
          <div class="px-2 mb-4 mt-4">
            <div class="tab-content rounded-0" id="nav-tabContent">
              <div
                class="tab-pane fade show active"
                id="form-pesan-pesawat"
                role="tabpanel"
                aria-labelledby="form-pesan-pesawat"
              >
                <div class="mx-2 mt-3">
                  <button class="btn me-2 btn-sm btn-outline-primary full-width-sm mb-2-sm" :class="{ 'btn-primary text-white': flightType === 'Pergi/Pulang' }" @click="flightType = 'Pergi/Pulang'">Sekali Jalan / Pulang Pergi</button>
                  <button class="btn btn-sm btn-outline-primary full-width-sm" :class="{ 'btn-primary text-white': flightType === 'multikota' }" @click="flightType = 'multikota'">Multi Kota</button>
                </div>
                <FormPesanTiketPesawat v-if="flightType === 'Pergi/Pulang'" />
                <FormPesanMultiCity v-if="flightType === 'multikota'" />
              </div>
              <div
                  class="tab-pane fade"
                  id="form-pesan-pesawat-internasional"
                  role="tabpanel"
                  aria-labelledby="form-pesan-pesawat-internasional"
                >
                <FormPesanTiketPesawatInternasional />
              </div>
              <div
                class="tab-pane fade"
                id="form-pesan-kereta-api"
                role="tabpanel"
                aria-labelledby="pesan-kereta-api"
              >
                <FormPesanTiketKeretaApi />
              </div>
              <div
                class="tab-pane fade"
                id="form-pesan-pelni"
                role="tabpanel"
                aria-labelledby="pesan-pelni"
              >
                <FormPesanTiketPelni />
              </div>
              <div
                class="tab-pane fade"
                id="form-pesan-hotel"
                role="tabpanel"
                aria-labelledby="pesan-hotel"
              >
                <FormPesanHotel />
              </div>
              <div
                class="tab-pane fade"
                id="form-pesan-ppob"
                role="tabpanel"
                aria-labelledby="pesan-ppob"
              >
                <FormPesanPPOB />
              </div>
            </div>
        </div>
      </div>
    </div>
    <!-- End Card Transaksi -->
</template>
